import React, { Component } from 'react';

class FindMyBusSkeleton extends Component {
    render() {
        const skeletonRows = Array(6).fill(0);
        const { onlyTable } = this.props;

        return (
            <div className="skeleton-page-wrapper">
                <style>{`
          .skeleton-page-wrapper {
            display: flex;
            min-height: 100vh;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background-color: #fff;
          }

          .pulse {
            background: #eee;
            background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
            border-radius: 4px;
            background-size: 200% 100%;
            animation: 1.5s shine linear infinite;
          }

          @keyframes shine {
            to { background-position-x: -200%; }
          }

          .sk-sidebar {
            width: 200px;
            border-right: 1px solid #e0e0e0;
            padding: 20px 15px;
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .sk-sidebar-item {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .sk-back-arrow { width: 18px; height: 18px; border-radius: 50%; }
          .sk-sidebar-text { width: 120px; height: 14px; }

          .sk-main-content {
            flex: 1;
            padding: 20px 40px;
          }
          
          .sk-header { margin-bottom: 30px; }
          .sk-title { width: 280px; height: 28px; margin-bottom: 15px; }
          .sk-toggle-row { display: flex; align-items: center; gap: 15px; }
          .sk-toggle-text { width: 160px; height: 16px; }
          .sk-toggle-switch { width: 35px; height: 18px; border-radius: 10px; }

          .sk-filters { 
            display: flex; 
            justify-content: space-between; 
            align-items: flex-end;
            margin-bottom: 25px; 
          }

          .sk-date-group { display: flex; gap: 30px; }
          .sk-date-field { width: 110px; height: 35px; margin-top: 8px; border: 1px solid #eee; }
          .sk-search-bar { width: 280px; height: 35px; border: 1px solid #eee; }

          .sk-table { border: 1px solid #e0e0e0; width: 100%; }
          .sk-thead { background-color: #f8f9fa; border-bottom: 2px solid #eee; display: flex; padding: 12px 10px; }
          .sk-tr { display: flex; padding: 15px 10px; border-bottom: 1px solid #eee; align-items: center; }
          .sk-th, .sk-td { flex: 1; padding: 0 5px; }
          .sk-td-small { flex: 0.3; display: flex; justify-content: center; }
          
          .sk-icon { width: 20px; height: 16px; border-radius: 2px; }
          .sk-footer { margin-top: 20px; display: flex; justify-content: space-between; align-items: center; }
        `}</style>

                {!onlyTable && (
                    <aside className="sk-sidebar">
                        <div className="sk-sidebar-item">
                            <div className="pulse sk-back-arrow" />
                            <div className="pulse sk-sidebar-text" />
                        </div>
                    </aside>
                )}
                <main className="sk-main-content">
                    {!onlyTable && (
                        <div className="sk-header">
                            <div className="pulse sk-title" />
                            <div className="sk-toggle-row">
                                <div className="pulse sk-toggle-text" />
                                <div className="pulse sk-toggle-switch" />
                            </div>
                        </div>
                    )}
                    {!onlyTable && (
                        <div className="sk-filters">
                            <div className="sk-date-group">
                                <div>
                                    <div className="pulse" style={{ width: '30px', height: '10px' }} />
                                    <div className="pulse sk-date-field" />
                                </div>
                                <div>
                                    <div className="pulse" style={{ width: '25px', height: '10px' }} />
                                    <div className="pulse sk-date-field" />
                                </div>
                            </div>
                            <div className="pulse sk-search-bar" />
                        </div>
                    )}
                    <div className="sk-table">
                        <div className="sk-thead">
                            {['', '', '', '', '', '', ''].map((_, i) => (
                                <div key={i} className={i > 4 ? 'sk-td-small' : 'sk-th'}>
                                    <div className="pulse" style={{ width: '60%', height: '12px' }} />
                                </div>
                            ))}
                        </div>

                        {skeletonRows.map((_, index) => (
                            <div key={index} className="sk-tr">
                                <div className="sk-td">
                                    <div className="pulse" style={{ width: '80%', height: '14px' }} />
                                </div>
                                <div className="sk-td">
                                    <div className="pulse" style={{ width: '85%', height: '14px' }} />
                                </div>
                                <div className="sk-td">
                                    <div className="pulse" style={{ width: '70%', height: '14px' }} />
                                </div>
                                <div className="sk-td">
                                    <div className="pulse" style={{ width: '90%', height: '14px' }} />
                                </div>
                                <div className="sk-td">
                                    <div className="pulse" style={{ width: '88%', height: '14px' }} />
                                </div>
                                <div className="sk-td-small">
                                    <div className="pulse sk-icon" style={{ opacity: 0.3 }} />
                                </div>
                                <div className="sk-td-small">
                                    <div className="pulse sk-icon" style={{ opacity: 0.3 }} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="sk-footer">
                        <div className="pulse" style={{ width: '70px', height: '32px' }} />
                        <div className="pulse" style={{ width: '35px', height: '35px' }} />
                    </div>
                </main>
            </div>
        );
    }
}

export default FindMyBusSkeleton;
